<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import { useCatalogPage } from '@/composition/catalog/catalog-page-context';

  /**
   * A far category card before it mounts (plan §5.8): an empty card of the
   * estimated height, observed by the page's single IntersectionObserver.
   */
  const props = defineProps<{
    categoryId: number;
    height: number;
  }>();

  const { windowing } = useCatalogPage();
  const root = ref<HTMLElement | null>(null);

  onMounted(() => {
    if (root.value) windowing.observe(root.value, props.categoryId);
  });

  onBeforeUnmount(() => {
    if (root.value) windowing.unobserve(root.value);
  });
</script>

<template>
  <div
    ref="root"
    class="v2-catalog-card-placeholder"
    :style="{ height: `${height}px` }"
    aria-hidden="true"
  />
</template>

<style scoped lang="scss">
  .v2-catalog-card-placeholder {
    @apply tw-rounded-xl tw-border tw-border-solid tw-border-neutral-200 tw-bg-surface;
  }
</style>
